<template>
<div class="chapter">
<div class="inner_page">
<section id="ded" title="Dedication">
<h1 class="ded_h"><span class="right_1" epub:type="pagebreak" id="page_xi" title="xi"><a href="#/text/9780062878823_Contents#rded">Dedication</a></span></h1>
<div class="top3">
<p class="ded_pb"><i>To everyone who has struggled with mental health issues</i>—<i>and to those who have helped them.</i></p>
<p class="ded_pe"><i>In memory of Letty and Henry, whose lives inspire me, and Madelyn, whose daughter inspires me.</i><span class="right_1" epub:type="pagebreak" id="page_xii" title="xii"></span></p>
</div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062878823_Dedication.vue?4366d5da